import React, { useEffect, useState } from "react";
import "../styles/Home.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [navigateToDashboard, setNavigateToDashboard] =
    useState<boolean>(false);

  const handleSignUp = () => {
    console.log("I signed up!");
    setNavigateToDashboard(true);
  };

  const handleLogIn = () => {
    console.log("I logged in!");
    setNavigateToDashboard(true);
  };

  useEffect(() => {
    if (navigateToDashboard) {
      navigate("/dashboard");
    }
  }, [navigateToDashboard, navigate]);

  return (
    <section>
      <img
        className="shopping-cart"
        src="/assets/shoppingCart.jpg"
        alt="Shopping cart with nutritious foods"
      />
      <div className="logo-container">
        <p className="logo">Your Partner In Food Choice </p>
        <div className="button-container">
          <NavLink to="/dashboard">
            <button onClick={handleSignUp}>Sign Up</button>
          </NavLink>
        </div>
        <div className="button-container">
          <NavLink to="/dashboard">
            <button onClick={handleLogIn}>Log In</button>
          </NavLink>
        </div>
      </div>
      <div className="est">
        <p> © 2024 My W.I.C. Shopping Buddy, Inc.</p>
      </div>
      <p className="made-by">
        {" "}
        Made With{" "}
        <span
          style={{
            color: "red",
            fontSize: "24px",
            marginLeft: "6px",
            marginRight: "6px",
          }}
        >
          &#x2764;
        </span>{" "}
        by The EnhanceHERS
      </p>
    </section>
  );
};

export default Home;
